import React from "react";

import * as styles from "./TestStyle.module.css";

type TestDataActionProps = Readonly<{
  url: string;
  text: string;
}>;
export const TestDataAction = ({ url, text }: TestDataActionProps) => (
  <div className={styles.row}>
    <a className={styles.testExtra} target="_blank" rel="noopener noreferrer" href={url}>
      {text}
    </a>
  </div>
);
